import { createAction, props } from '@ngrx/store';
import { Parcel } from 'app/core/app.model';


interface DynamicData {
    upid: string;
    status: boolean;
    message: string;
    values: { [columnKey: string]: any };
}

export const addParcels = createAction('[Parcels] Add parcels', props<{ parcels: Parcel[] }>());

export const removeParcels = createAction('[Parcels] Remove parcels', props<{ upids: string[] }>());

export const clearParcels = createAction('[Parcels] Clear parcels');

export const selectColumns = createAction('[PropertiesTable] Select columns', props<{ columnKeys: string[] }>());

export const favorColumns = createAction('[PropertiesTable] Favor columns', props<{ columnKeys: string[] }>());

export const startTasks = createAction('[PropertiesTable] Start tasks', props<{ taskNames: string[]; upids: string[] }>());

export const taskResult = createAction('[PropertiesTable] Task result', props<{ taskName: string; dynamic: DynamicData[] }>());

export const taskFail = createAction('[PropertiesTable] Task fail', props<{ taskName: string; upids: string[]; reason: string }>());

export const taskComplete = createAction('[PropertiesTable] Task complete', props<{ taskName: string }>());

export const setLtsaCredentialsNotification = createAction('[PropertiesTable] Show bad credentials toast', props<{ value: boolean }>());
